export const PendingCategoryQueryKeys = {
  all: () => ["pendingCategories"],
  single: (pendingCategoryId: string | undefined) => [...PendingCategoryQueryKeys.all(), pendingCategoryId],
};
